<template>
  <div
    class="rete-layout"
    :style="{ gridTemplateColumns: layoutCols }"
  >
    <!-- Paleta (retrátil) -->
    <aside
      class="palette"
      :class="{ collapsed: paletteCollapsed }"
    >
      <div class="palette-header">
        <div class="ph-left">
          <i class="feather icon-package" />
          <span class="title">Components</span>
        </div>
        <b-button
          v-b-tooltip.hover
          size="sm"
          variant="light"
          class="toggle"
          :title="paletteCollapsed ? 'Expandir paleta' : 'Recolher paleta'"
          @click="togglePalette"
        >
          <i :class="paletteCollapsed ? 'feather icon-chevron-right' : 'feather icon-chevron-left'" />
        </b-button>
      </div>

      <ul class="palette-list">
        <!-- Somente “Novo estado” -->
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Novo estado em branco"
          @dragstart="onDragStart($event,'state')"
        >
          <i class="feather icon-plus-square mr-1" /> <span class="label">Novo estado</span>
          <small class="pill">node</small>
        </li>

        <!-- Ações -->
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Enviar texto"
          @dragstart="onDragStart($event,'act:send_text')"
        >
          <i class="feather icon-message-square mr-1" /> <span class="label">Enviar texto</span>
          <small class="pill">action</small>
        </li>
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Enviar botões"
          @dragstart="onDragStart($event,'act:send_buttons')"
        >
          <i class="feather icon-grid mr-1" /> <span class="label">Enviar botões</span>
          <small class="pill">action</small>
        </li>
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Enviar lista"
          @dragstart="onDragStart($event,'act:send_list')"
        >
          <i class="feather icon-list mr-1" /> <span class="label">Enviar lista</span>
          <small class="pill">action</small>
        </li>
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Perguntar variável"
          @dragstart="onDragStart($event,'act:ask_var')"
        >
          <i class="feather icon-help-circle mr-1" /> <span class="label">Perguntar variável</span>
          <small class="pill">action</small>
        </li>
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Consultar plataforma"
          @dragstart="onDragStart($event,'act:platform_lookup')"
        >
          <i class="feather icon-database mr-1" /> <span class="label">Consultar plataforma</span>
          <small class="pill">action</small>
        </li>
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Validar cliente"
          @dragstart="onDragStart($event,'act:validate_customer')"
        >
          <i class="feather icon-user-check mr-1" /> <span class="label">Validar cliente</span>
          <small class="pill">action</small>
        </li>
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Ir para (estado)"
          @dragstart="onDragStart($event,'act:goto')"
        >
          <i class="feather icon-corner-down-right mr-1" /> <span class="label">Ir para (estado)</span>
          <small class="pill">action</small>
        </li>
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Mudar modo (central)"
          @dragstart="onDragStart($event,'act:set_mode')"
        >
          <i class="feather icon-repeat mr-1" /> <span class="label">Mudar modo</span>
          <small class="pill">action</small>
        </li>
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Atribuir tags"
          @dragstart="onDragStart($event,'act:set_tags')"
        >
          <i class="feather icon-tags mr-1" /> <span class="label">Atribuir tags</span>
          <small class="pill">action</small>
        </li>
        <li
          v-b-tooltip.hover
          class="palette-item"
          draggable="true"
          title="Encerrar"
          @dragstart="onDragStart($event,'act:end')"
        >
          <i class="feather icon-x-square mr-1" /> <span class="label">Encerrar</span>
          <small class="pill">action</small>
        </li>
      </ul>

      <div
        v-show="!paletteCollapsed"
        class="palette-footer"
      >
        <b-button
          size="sm"
          block
          variant="outline-primary"
          @click="addStateQuick"
        >
          + Estado
        </b-button>
      </div>
    </aside>

    <!-- Centro -->
    <section class="workbench">
      <div class="toolbar">
        <b-button-group
          size="sm"
          class="btns"
        >
          <b-button
            title="Undo"
            @click="undo"
          >
            <i class="feather icon-rotate-ccw" /></b-button>
          <b-button
            title="Redo"
            @click="redo"
          >
            <i class="feather icon-rotate-cw" /></b-button>
          <b-button
            title="Fit to screen"
            @click="fitView"
          >
            <i class="feather icon-maximize-2" /></b-button>
        </b-button-group>
      </div>

      <div
        ref="canvas"
        class="canvas with-grid"
        @dragover.prevent
        @drop="onDrop"
      >
        <div
          ref="editor"
          class="editor"
        />
      </div>
    </section>

    <!-- Inspector -->
    <aside
      v-if="activeNode"
      class="inspector"
    >
      <div class="inspector-header">
        <div class="title">
          Properties
        </div>
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="activeNode=null"
        >
          <i class="feather icon-x" /></b-button>
      </div>

      <b-form-group
        label="Component Title"
        class="mt-2"
      >
        <b-form-input
          v-model="activeNode.data.stateId"
          @input="onNodeRename"
        />
      </b-form-group>

      <b-card
        class="mb-2"
        body-class="p-2"
      >
        <div class="ins-section">
          <div class="ins-section-title">
            Ações (on_enter)
          </div>
          <b-button
            size="sm"
            variant="outline-primary"
            @click="addAction()"
          >
            + ação
          </b-button>
        </div>

        <action-list
          :actions.sync="activeNode.data.actions"
          :state-names="stateNames"
          :state-name="activeNode.data.stateId"
          :state-rules="currentStateRules(activeNode.data.stateId)"
          :bot-uuid="botUuid"
          :auto-rules="true"
          @change="onNodeDataChange"
          @rule-for="onAutoRuleFor"
          @rule-rename="onAutoRuleRename"
          @rule-remove="onAutoRuleRemove"
        />
      </b-card>
    </aside>
  </div>
</template>

<script>
import Rete from 'rete'
import ConnectionPlugin from 'rete-connection-plugin'
import VueRenderPlugin from 'rete-vue-render-plugin'
import ContextMenuPlugin from 'rete-context-menu-plugin'
import MinimapPlugin from 'rete-minimap-plugin'
import HistoryPlugin from 'rete-history-plugin'

import ReteStateNode from './ReteStateNode.vue'
import ActionList from './ActionList.vue'

const anySocket = new Rete.Socket('any')
const SVG_NS = 'http://www.w3.org/2000/svg'
const XLINK_NS = 'http://www.w3.org/1999/xlink'

class StateComponent extends Rete.Component {
  constructor() {
    super('state')
    this.data.render = 'vue'
    this.data.component = ReteStateNode
  }

  builder(node) {
    node.addInput(new Rete.Input('in', 'in', anySocket, true)) // múltiplas entradas
    node.addOutput(new Rete.Output('out', 'out', anySocket))
    node.data.stateId = node.data.stateId || `estado_${Math.floor(Math.random() * 10000)}`
    node.data.actions = node.data.actions || []
    node.data.transitions = node.data.transitions || [] // só para UI
    node.data._isStart = !!node.data._isStart
    return node
  }

  worker() {}
}

export default {
  name: 'FlowBuilder',
  components: { ActionList },
  props: {
    value: { type: Object, default: null },
    botUuid: { type: String, default: null },
  },
  data() {
    return {
      editor: null,
      stateComp: null,
      activeNode: null,
      zoomLabel: '100%',
      gridSize: 20,
      edgeLabels: new Map(),
      paletteCollapsed: false,
      paletteWide: 260,
      paletteNarrow: 56,
      layoutResizeTimer: null,
      _isPanning: false,
      _allowConnMutations: false,
    }
  },
  computed: {
    stateNames() { return this.editor ? this.editor.nodes.map(n => n.data.stateId) : [] },
    layoutCols() {
      const left = `${this.paletteCollapsed ? this.paletteNarrow : this.paletteWide}px`
      const right = this.activeNode ? '360px' : '0px'
      return `${left} 1fr ${right}`
    },
  },
  watch: {
    paletteCollapsed() { this.scheduleResize() },
  },
  mounted() {
    this.init()
    window.addEventListener('resize', this.onLayoutResize)
  },
  beforeDestroy() {
    try { this.editor?.destroy() } catch (e) {}
    window.removeEventListener('resize', this.onLayoutResize)
    this.detachPanCursorHandlers()
  },
  methods: {
    togglePalette() { this.paletteCollapsed = !this.paletteCollapsed },

    async init() {
      this.editor = new Rete.NodeEditor('manyconvert@1.0.0', this.$refs.editor)
      this.editor.use(ConnectionPlugin)
      this.editor.use(VueRenderPlugin)
      this.editor.use(ContextMenuPlugin, {
        searchBar: true,
        items: node => ({
          Duplicar: () => this.duplicateNode(node),
          'Definir como Start': () => this.setAsStart(node),
          Remover: () => this.editor.removeNode(node),
        }),
      })
      this.editor.use(MinimapPlugin, { width: 160, height: 110 })
      this.editor.use(HistoryPlugin)

      // bloquear criação/remoção manual de conexões
      this.editor.on('connectioncreate', () => (!this._allowConnMutations ? false : undefined))
      this.editor.on('connectionremove', () => (!this._allowConnMutations ? false : undefined))

      this.stateComp = new StateComponent()
      this.editor.register(this.stateComp)

      this.editor.on('zoom', ({ transform }) => {
        this.zoomLabel = `${Math.round((transform?.k || 1) * 100)}%`
      })

      // abre Properties com duplo clique + preenche preview
      this.editor.on('rendernode', ({ el, node }) => {
        el.classList.add('rete-node-card')
        el.addEventListener('dblclick', () => { this.activeNode = node })
        this.fillPreview(node, el.querySelector('.node-preview'))
      })

      // remover nó → limpar labels + remover referências de goto
      this.editor.on('noderemoved', node => {
        if (this.activeNode?.id === node?.id) this.activeNode = null

        const dead = []
        this.edgeLabels.forEach((item, key) => {
          const c = item.pathEl?.__reteConnection
          if (!c) return
          if (c.output?.node === node || c.input?.node === node) dead.push(key)
        })
        dead.forEach(k => { const it = this.edgeLabels.get(k); it?.textEl?.remove(); this.edgeLabels.delete(k) })

        const removedName = this.norm(node?.data?.stateId)
        if (removedName) this.scrubReferencesToState(removedName)

        this.$nextTick(() => this.rebuildConnectionsFromActions())
      })

      // labels (textPath)
      this.editor.on('renderconnection', ({ el, connection }) => {
        const pathEl = this.getPathElFromConnectionEl(el)
        if (pathEl) { pathEl.__reteConnection = connection; this.createOrUpdateEdgeLabel(connection, pathEl) }
      })
      this.editor.on('updateconnection', ({ el, connection }) => {
        const pathEl = this.getPathElFromConnectionEl(el)
        if (pathEl) { pathEl.__reteConnection = connection; this.createOrUpdateEdgeLabel(connection, pathEl) } else { this.updateEdgeLabelText(connection) }
      })
      this.editor.on('connectionremoved', c => { this.removeEdgeLabel(c) })

      // snap
      this.editor.on('nodetranslated', ({ node }) => {
        const [x, y] = node.position
        const gx = Math.round(x / this.gridSize) * this.gridSize
        const gy = Math.round(y / this.gridSize) * this.gridSize
        if (gx !== x || gy !== y) { node.position = [gx, gy]; try { this.editor.view.update() } catch (e) {} }
      })

      // cursor pan
      this.attachPanCursorHandlers()

      // carregar (sem transitions no schema)
      await this.loadFromSchema(this.value || { start: 'menu', states: { menu: { on_enter: [] } } })
      window.addEventListener('keydown', this.onKey)
      this.fitView()
    },

    /* ===== PAN cursor handlers ===== */
    attachPanCursorHandlers() {
      const areaEl = this.editor?.view?.area?.el || this.$refs.editor
      if (!areaEl) return
      areaEl.addEventListener('mousedown', this.onAreaPointerDown, true)
      window.addEventListener('mouseup', this.onAreaPointerUp, true)
      window.addEventListener('mouseleave', this.onAreaPointerUp, true)
    },
    detachPanCursorHandlers() {
      const areaEl = this.editor?.view?.area?.el || this.$refs.editor
      if (!areaEl) return
      areaEl.removeEventListener('mousedown', this.onAreaPointerDown, true)
      window.removeEventListener('mouseup', this.onAreaPointerUp, true)
      window.removeEventListener('mouseleave', this.onAreaPointerUp, true)
    },
    onAreaPointerDown(e) {
      const inNode = e.target && (e.target.closest?.('.node') || e.target.closest?.('.rete-node-card'))
      if (e.button === 0 && !inNode) {
        this._isPanning = true
        this.$refs.canvas.classList.add('panning')
        this.$refs.editor.classList.add('panning')
      }
    },
    onAreaPointerUp() {
      if (this._isPanning) {
        this._isPanning = false
        this.$refs.canvas.classList.remove('panning')
        this.$refs.editor.classList.remove('panning')
      }
    },

    /* ===== conexões: DOM helpers ===== */
    getPathElFromConnectionEl(el) { return el?.querySelector?.('path.main-path, path') || null },
    getConnViewEl(connection) {
      const vc = this.editor?.view?.connections
      if (!vc) return null
      if (typeof vc.get === 'function') return vc.get(connection)?.el || null
      if (Array.isArray(vc)) return (vc.find(v => v.connection === connection || v === connection)?.el) || null
      return null
    },

    /* ===== preview ===== */
    refreshNodeView(node, el) {
      const element = el || this.editor?.view?.nodes?.get(node)?.el
      if (!element) return
      this.fillPreview(node, element.querySelector('.node-preview'))
    },
    fillPreview(node, container) {
      if (!container) return
      while (container.firstChild) container.removeChild(container.firstChild)
      const acts = node.data.actions || []

      const txt = acts.find(a => a.action === 'send_text')
      const textBox = document.createElement('div')
      textBox.className = 'pv-text'
      textBox.textContent = (txt && (txt.text || txt.body)) ? this.truncate(txt.text || txt.body, 160) : 'send_text'
      container.appendChild(textBox)

      const sb = acts.find(a => a.action === 'send_buttons' && Array.isArray(a.buttons))
      const sl = acts.find(a => a.action === 'send_list' && (Array.isArray(a.items) || a.sections?.[0]?.rows?.length))
      if (sb || sl) {
        const wrap = document.createElement('div')
        wrap.className = 'pv-actions'
        if (sb?.buttons?.length) {
          sb.buttons.forEach(b => { const chip = document.createElement('div'); chip.className = 'pv-chip'; chip.textContent = b?.title || 'button'; wrap.appendChild(chip) })
        }
        if (sl) {
          if (Array.isArray(sl.items)) sl.items.forEach(it => { const chip = document.createElement('div'); chip.className = 'pv-chip'; chip.textContent = it?.label || it?.title || 'option'; wrap.appendChild(chip) })
          if (sl.sections?.[0]?.rows?.length) sl.sections[0].rows.forEach(r => { const chip = document.createElement('div'); chip.className = 'pv-chip'; chip.textContent = r?.title || r?.label || 'option'; wrap.appendChild(chip) })
        }
        container.appendChild(wrap)
      }
    },

    /* ===== labels (textPath) ===== */
    connKey(c) { return `${c?.output?.node?.id}__${c?.input?.node?.id}` },
    getOrCreateLabelsLayer(svg) {
      if (!svg) return null
      let g = svg.querySelector('g.rete-edge-labels')
      if (!g) { g = document.createElementNS(SVG_NS, 'g'); g.setAttribute('class', 'rete-edge-labels'); svg.appendChild(g) }
      return g
    },
    ensurePathId(pathEl, key) { if (!pathEl) return null; if (!pathEl.getAttribute('id')) pathEl.setAttribute('id', `conn-${key}`); return pathEl.getAttribute('id') },
    createOrUpdateEdgeLabel(connection, pathEl) {
      if (!(pathEl instanceof SVGPathElement)) return
      const svg = pathEl.ownerSVGElement; if (!svg) return
      const key = this.connKey(connection)
      const layer = this.getOrCreateLabelsLayer(svg); if (!layer) return
      const pid = this.ensurePathId(pathEl, key)
      let item = this.edgeLabels.get(key)
      if (!item) {
        const textEl = document.createElementNS(SVG_NS, 'text')
        textEl.setAttribute('class', 'edge-label-text')
        const textPath = document.createElementNS(SVG_NS, 'textPath')
        textPath.setAttributeNS(XLINK_NS, 'xlink:href', `#${pid}`)
        textPath.setAttribute('href', `#${pid}`)
        textPath.setAttribute('startOffset', '50%')
        textPath.setAttribute('text-anchor', 'middle')
        textEl.appendChild(textPath)
        layer.appendChild(textEl)
        item = {
          textEl, textPath, pathEl, svg,
        }
        this.edgeLabels.set(key, item)
      } else {
        item.pathEl = pathEl
        item.svg = svg
        const curPid = this.ensurePathId(pathEl, key)
        item.textPath.setAttributeNS(XLINK_NS, 'xlink:href', `#${curPid}`)
        item.textPath.setAttribute('href', `#${curPid}`)
      }
      item.textPath.textContent = this.connLabel(connection) || ''
    },
    updateEdgeLabelText(connection) {
      const key = this.connKey(connection)
      const it = this.edgeLabels.get(key)
      if (!it) return
      it.textPath.textContent = this.connLabel(connection) || ''
      const pid = this.ensurePathId(it.pathEl, key)
      if (pid) {
        it.textPath.setAttributeNS(XLINK_NS, 'xlink:href', `#${pid}`)
        it.textPath.setAttribute('href', `#${pid}`)
      }
    },
    removeEdgeLabel(connection) {
      const key = this.connKey(connection)
      const it = this.edgeLabels.get(key)
      if (!it) return
      it.textEl.remove()
      this.edgeLabels.delete(key)
    },
    refreshAllEdgeLabels() {
      (this.editor?.connections || []).forEach(c => {
        const elDiv = this.getConnViewEl(c)
        const pathEl = elDiv ? this.getPathElFromConnectionEl(elDiv) : null
        if (pathEl) { pathEl.__reteConnection = c; this.createOrUpdateEdgeLabel(c, pathEl) }
      })
    },
    connLabel(connection) {
      const from = connection?.output?.node
      const to = connection?.input?.node
      if (!from || !to) return ''
      const labels = (from.data.transitions || [])
        .filter(t => t.to === to.data.stateId)
        .map(t => t.label)
        .filter(Boolean)
      return labels.length ? Array.from(new Set(labels)).join('/') : ''
    },

    /* ===== gate p/ mutações programáticas ===== */
    async withConnMutations(fn) {
      const prev = this._allowConnMutations
      this._allowConnMutations = true
      try { await fn() } finally { this._allowConnMutations = prev }
    },

    /* ===== util ===== */
    norm(v) { return String(v || '').trim() },

    /* ===== remove referências a um estado deletado ===== */
    scrubReferencesToState(targetName) {
      const T = this.norm(targetName)
      if (!T) return;
      (this.editor?.nodes || []).forEach(n => {
        const acts = n.data.actions || []
        const sb = acts.find(a => a && a.action === 'send_buttons')
        if (sb?.buttons?.length) {
          sb.buttons.forEach(b => {
            if (!b) return
            if (b.click_action === 'goto') {
              const to = this.norm(b.goto_state || b.title || '')
              if (to === T) {
                b.click_action = ''
                if (b.goto_state) b.goto_state = ''
              }
            }
          })
        }

        const sl = acts.find(a => a && a.action === 'send_list')
        if (sl?.sections?.[0]?.rows?.length) {
          sl.sections[0].rows.forEach(r => {
            if (!r) return
            if (r.click_action === 'goto') {
              const to = this.norm(r.goto_state || r.title || r.label || '')
              if (to === T) {
                r.click_action = ''
                if (r.goto_state) r.goto_state = ''
              }
            }
          })
        }
        if (Array.isArray(sl?.items)) {
          sl.items.forEach(it => {
            const to = this.norm(it?.goto_state || '')
            if (to && to === T) it.goto_state = ''
          })
        }
      })
    },

    /* ===== derivar gotos de um nó ===== */
    deriveTransitionsFromActions(node) {
      const out = []
      const acts = node?.data?.actions || []

      // Botões
      const sb = acts.find(a => a && a.action === 'send_buttons')
      if (sb?.buttons?.length) {
        sb.buttons.forEach((b, i) => {
          if (!b || b.click_action !== 'goto') return
          const label = this.norm(b.title || `Opção ${i + 1}`)
          const to = this.norm(b.goto_state || label)
          if (to) out.push({ to, label })
        })
      }

      // Lista (novo formato -> rows)
      const sl = acts.find(a => a && a.action === 'send_list')
      if (sl?.sections?.[0]?.rows?.length) {
        sl.sections[0].rows.forEach((r, i) => {
          if (!r || r.click_action !== 'goto') return
          const label = this.norm(r.title || r.label || `Item ${i + 1}`)
          const to = this.norm(r.goto_state || label)
          if (to) out.push({ to, label })
        })
      }

      // Lista (antigo -> items)
      if (Array.isArray(sl?.items)) {
        sl.items.forEach((it, i) => {
          const label = this.norm(it?.label || it?.title || `Item ${i + 1}`)
          const to = this.norm(it?.goto_state || '')
          if (to) out.push({ to, label })
        })
      }

      return out
    },

    /* ===== RECONCILIAÇÃO POR NÓ ===== */
    async rebuildConnectionsFromActions() {
      const allNodes = this.editor?.nodes || []

      await this.withConnMutations(async () => {
        for (const from of allNodes) {
          const desiredList = this.deriveTransitionsFromActions(from)
          const desiredMap = new Map()
          desiredList.forEach(t => {
            if (!t.to) return
            const key = this.norm(t.to)
            if (!desiredMap.has(key)) desiredMap.set(key, new Set())
            if (t.label) desiredMap.get(key).add(this.norm(t.label))
          })

          const out = from.outputs.get('out')
          const existing = (out?.connections || []).slice()

          // remover stales/duplicadas
          const seenTo = new Set()
          for (const c of existing) {
            const toName = this.norm(c?.input?.node?.data?.stateId)
            if (!toName || !desiredMap.has(toName)) {
              this.removeEdgeLabel(c); this.editor.removeConnection(c); continue
            }
            if (seenTo.has(toName)) { this.removeEdgeLabel(c); this.editor.removeConnection(c); continue }
            seenTo.add(toName)
          }

          // criar faltantes
          const byName = new Map(allNodes.map(n => [this.norm(n.data.stateId), n]))
          for (const toName of desiredMap.keys()) {
            const hasConn = (out?.connections || []).some(c => this.norm(c?.input?.node?.data?.stateId) === toName)
            if (!hasConn) {
              let toNode = byName.get(toName)
              if (!toNode) toNode = await this.ensureNodeByName(toName)
              await this.editor.connect(out, toNode.inputs.get('in'))
            }
          }

          // transitions só para UI
          const trans = []
          for (const [toName, labelsSet] of desiredMap.entries()) {
            const label = Array.from(labelsSet).join('/')
            trans.push({ to: toName, label })
          }
          from.data.transitions = trans

          this.refreshNodeView(from)
        }
      })

      this.emitDefinition()
      this.$nextTick(() => {
        try { this.editor.view.update() } catch (e) {}
        this.refreshAllEdgeLabels()
      })
    },

    /* ===== helpers de nó/drag/zoom ===== */
    findNodeByName(name) { return this.editor.nodes.find(n => this.norm(n.data.stateId) === this.norm(name)) || null },
    async ensureNodeByName(name) {
      let n = this.findNodeByName(name)
      if (n) return n
      n = await this.stateComp.createNode({ stateId: name, actions: [], transitions: [] })
      n.position = this.randomPos()
      this.editor.addNode(n)
      n.data._isStart = (this.value?.start && this.norm(this.value.start) === this.norm(name))
      this.refreshNodeView(n)
      return n
    },

    onDragStart(ev, type) { ev.dataTransfer.setData('text/plain', type) },

    async onDrop(ev) {
      const type = ev.dataTransfer.getData('text/plain')
      if (!type) return
      const { x, y } = this.clientToScene(ev.clientX, ev.clientY)

      if (type === 'state') {
        const node = await this.stateComp.createNode({ stateId: this.uniqueStateId('Estado'), actions: [], transitions: [] })
        node.position = [x, y]; this.editor.addNode(node)
        this.refreshNodeView(node)
        await this.rebuildConnectionsFromActions()
        return
      }

      if (type.startsWith('act:')) {
        const kind = type.split(':')[1]
        const action = this.defaultActionFor(kind)
        const node = await this.stateComp.createNode({
          stateId: this.uniqueStateId('Estado'),
          actions: action ? [action] : [],
          transitions: [],
        })
        node.position = [x, y]; this.editor.addNode(node)
        this.refreshNodeView(node)
        await this.rebuildConnectionsFromActions()
      }
    },

    defaultActionFor(kind) {
      switch (kind) {
        case 'send_text':
          return { action: 'send_text', text: '' }
        case 'send_buttons':
          return {
            action: 'send_buttons', header: '', body: '', footer: '', buttons: [],
          }
        case 'send_list':
          return {
            action: 'send_list', header: '', body: '', button_text: 'Ver opções', sections: [{ title: 'Opções', rows: [] }],
          }
        case 'ask_var':
          return { action: 'ask_var', var: '', prompt: '' }
        case 'platform_lookup':
          return { action: 'platform_lookup', op: 'status_pedido', messages: {} }
        case 'validate_customer':
          return { action: 'validate_customer' }
        case 'goto':
          return { action: 'goto', state: '' }
        case 'set_mode':
          return { action: 'set_mode', mode: 'central', assign_random_agent_ids: [] }
        case 'set_tags':
          return { action: 'set_tags', tags: [] }
        case 'end':
          return { action: 'end' }
        default:
          return null
      }
    },

    clientToScene(clientX, clientY) {
      const { area } = this.editor.view
      const rect = this.$refs.editor.getBoundingClientRect()
      const k = area.transform.k || 1
      const x = (clientX - rect.left - area.transform.x) / k
      const y = (clientY - rect.top - area.transform.y) / k
      const gx = Math.round(x / this.gridSize) * this.gridSize
      const gy = Math.round(y / this.gridSize) * this.gridSize
      return { x: gx, y: gy }
    },
    zoomIn() { this.editor.view.area.zoom(0.1, 0, 0) },
    zoomOut() { this.editor.view.area.zoom(-0.1, 0, 0) },
    fitView() {
      if (!this.editor?.nodes?.length) return
      const xs = this.editor.nodes.map(n => n.position[0])
      const ys = this.editor.nodes.map(n => n.position[1])
      const minX = Math.min(...xs); const
        maxX = Math.max(...xs)
      const minY = Math.min(...ys); const
        maxY = Math.max(...ys)
      const cx = (minX + maxX) / 2; const
        cy = (minY + maxY) / 2
      const { area } = this.editor.view
      area.transform.k = 0.9
      area.transform.x = this.$refs.editor.clientWidth / 2 - cx
      area.transform.y = this.$refs.editor.clientHeight / 2 - cy
      area.update()
      this.zoomLabel = '90%'
    },
    autoArrange() {
      const nodes = this.editor.nodes.slice()
      const cols = Math.max(1, Math.ceil(Math.sqrt(nodes.length)))
      const gapX = 380; const gapY = 220; const baseX = 80; const
        baseY = 80
      nodes.forEach((n, i) => { n.position = [baseX + (i % cols) * gapX, baseY + Math.floor(i / cols) * gapY] })
      try { this.editor.view.update() } catch (e) {}
    },
    undo() { try { this.editor.trigger('undo') } catch (e) {} },
    redo() { try { this.editor.trigger('redo') } catch (e) {} },
    addStateQuick() { this.onDrop({ dataTransfer: { getData: () => 'state' }, clientX: window.innerWidth * 0.5, clientY: 180 }) },
    setAsStart(node) {
      const def = this.getDefinition()
      def.start = node?.data?.stateId || def.start
      this.$emit('input', def)
      this.updateStartFlags(def.start)
    },
    uniqueStateId(base) {
      const names = new Set(this.editor.nodes.map(n => n.data.stateId))
      let name = base; let
        i = 1
      while (names.has(name)) { name = `${base} ${i++}` }
      return name
    },
    addAction() { if (!this.activeNode) return; this.activeNode.data.actions.push({ action: 'send_text', text: '' }); this.onNodeDataChange() },
    onNodeRename() {
      if (!this.activeNode) return
      this.refreshNodeView(this.activeNode)
      this.rebuildConnectionsFromActions()
    },
    onNodeDataChange() {
      if (!this.activeNode) return
      this.refreshNodeView(this.activeNode)
      this.rebuildConnectionsFromActions()
    },

    /* ===== regras p/ ActionList ===== */
    currentStateRules(stateId) {
      const rules = []
      this.editor.nodes.forEach(n => {
        (n.data.transitions || []).forEach(t => {
          if (t.to === stateId) {
            rules.push({ if: { interactive_reply_id: this.slug(t.label) }, then: [{ action: 'goto', state: stateId }] })
          }
        })
      })
      return rules
    },
    onAutoRuleFor() { this.onNodeDataChange() },
    onAutoRuleRename() { this.onNodeDataChange() },
    onAutoRuleRemove() { this.onNodeDataChange() },

    /* ===== definição ===== */
    getDefinition() {
      const states = {}
      for (const n of this.editor.nodes) {
        const name = n.data.stateId
        const actions = JSON.parse(JSON.stringify(n.data.actions || []))
        // NÃO salvar transitions no schema
        states[name] = { on_enter: actions }
      }
      const start = (this.value && this.value.start && states[this.value.start]) ? this.value.start : Object.keys(states)[0]
      // Se seu schema não aceitar "settings", remova a linha abaixo
      const settings = this.value?.settings || { autoclose_minutes: 0 }
      return { start, states, settings }
    },
    emitDefinition() {
      const def = this.getDefinition()
      this.$emit('input', def)
      this.updateStartFlags(def.start)
    },
    updateStartFlags(startName) {
      const target = this.norm(startName)
      this.editor.nodes.forEach(n => { n.data._isStart = (this.norm(n.data.stateId) === target) })
    },

    async loadFromSchema(def) {
      const states = def?.states || {}
      for (const [stateId, st] of Object.entries(states)) {
        const node = await this.stateComp.createNode({ stateId, actions: st.on_enter || [], transitions: [] })
        node.position = this.randomPos()
        node.data._isStart = (this.norm(def.start) === this.norm(stateId))
        this.editor.addNode(node)
      }
      await this.rebuildConnectionsFromActions()
      this.editor.view.resize()
      this.$nextTick(() => {
        const out = this.getDefinition()
        this.$emit('input', out)
        this.updateStartFlags(out.start)
        this.refreshAllEdgeLabels()
      })
    },

    /* ===== Layout resize helpers ===== */
    scheduleResize() {
      clearTimeout(this.layoutResizeTimer)
      this.$nextTick(() => { this.layoutResizeTimer = setTimeout(this.onLayoutResize, 50) })
    },
    onLayoutResize() {
      if (!this.editor) return
      try { this.editor.view.resize() } catch (e) {}
      this.refreshAllEdgeLabels()
    },

    /* Helpers */
    truncate(s, n) { const str = String(s || ''); return str.length <= n ? str : (`${str.slice(0, n - 1)}…`) },
    slug(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s_-]/g, '')
        .trim()
        .replace(/\s+/g, '_')
        .replace(/_+/g, '_')
    },
    randomPos() { const x = 80 + Math.random() * 520; const y = 80 + Math.random() * 360; return [x, y] },
    duplicateNode(node) {
      const clone = JSON.parse(JSON.stringify(node.data || {}))
      clone.stateId = this.uniqueStateId(clone.stateId || 'Estado')
      this.stateComp.createNode(clone).then(n => { n.position = [node.position[0] + 40, node.position[1] + 40]; this.editor.addNode(n); this.onNodeDataChange() })
    },
    onKey(e) {
      if ((e.key === 'Delete' || e.key === 'Backspace') && this.activeNode) {
        e.preventDefault(); this.editor.removeNode(this.activeNode); this.activeNode = null; this.rebuildConnectionsFromActions()
      }
      const mod = e.ctrlKey || e.metaKey
      if (mod && (e.key === '=' || e.key === '+')) { e.preventDefault(); this.zoomIn() }
      if (mod && e.key === '-') { e.preventDefault(); this.zoomOut() }
      if (mod && e.key === '0') { e.preventDefault(); this.fitView() }
    },
  },
}
</script>

  <style scoped>
  /* ===== Layout ===== */
  .rete-layout{
    display:grid;
    grid-template-rows:100vh;
    overflow:hidden;
  }

  /* ===== Palette retrátil ===== */
  .palette{
    background:#fff; border-right:1px solid #e9edf3; padding:12px; display:flex; flex-direction:column; overflow:hidden;
  }
  .palette.collapsed{ padding:8px 6px; }
  .palette-header{ display:flex; align-items:center; justify-content:space-between; margin-bottom:8px; }
  .palette-header .ph-left{ display:flex; align-items:center; gap:8px; }
  .palette-header .title{ font-weight:700; font-size:14px; color:#4a5161; }
  .palette-header .toggle{ border-radius:8px; }

  .palette-list{ list-style:none; padding:0; margin:0; flex:1; overflow:auto; }
  .palette-item{
    display:flex; align-items:center; justify-content:space-between;
    padding:8px 10px; border:1px solid #e9edf3; border-radius:10px; background:#fafcff;
    margin-bottom:8px; cursor:grab; transition:.15s ease box-shadow,.15s ease transform;
  }
  .palette-item:active{ cursor:grabbing; transform:scale(.99); }
  .palette-item:hover{ box-shadow:0 4px 16px rgba(50,72,128,.08); }
  .palette-item .pill{ background:#e9f2ff; color:#1d4ed8; font-size:10px; padding:2px 6px; border-radius:999px; }
  .palette .label{ white-space:nowrap; }
  .palette.collapsed .label,
  .palette.collapsed .palette-footer,
  .palette.collapsed .ph-left .title{ display:none; }
  .palette.collapsed .palette-item{ justify-content:center; }
  .palette.collapsed .palette-item .pill{ display:none; }

  .palette-footer{ padding-top:8px; }

  /* ===== Workbench / Toolbar ===== */
  .workbench{ position:relative; min-width:0; }
  .toolbar{
    position:absolute; z-index:5; top:10px; left:50%; transform:translateX(-50%);
    display:flex; align-items:center; background:rgba(255,255,255,.9);
    border:1px solid #e9edf3; border-radius:12px; padding:6px 8px; box-shadow:0 6px 18px rgba(0,0,0,.06);
  }
  .toolbar .btns>.btn{ border-radius:8px !important; }
  .toolbar .muted{ color:#6b7280; background:#f3f4f6; border-color:#e5e7eb; }
  .ml-1{ margin-left:.5rem }

  /* Canvas claro + grid */
  .canvas{ position:absolute; inset:0; background:#f7f9fc; z-index:1; }
  .canvas.with-grid{
    background-image:
      linear-gradient(to right, rgba(0,0,0,.05) 1px, transparent 1px),
      linear-gradient(to bottom, rgba(0,0,0,.05) 1px, transparent 1px);
    background-size:20px 20px, 20px 20px;
  }

  /* Cursores */
  .canvas, .editor { cursor: default; }
  .canvas.panning, .editor.panning { cursor: move; }

  /* camada do editor */
  .editor{ position:absolute; inset:0; z-index:1; }

  /* ===== Inspector acima dos nós ===== */
  .inspector{
    position: relative;
    z-index: 10;            /* garante nós por baixo */
    background:#fff;
    border-left:1px solid #e9edf3;
    padding:12px; overflow:auto;
    box-shadow: -6px 0 18px rgba(0,0,0,.06);
  }
  .inspector-header{ display:flex; align-items:center; justify-content:space-between; }
  .inspector .title{ font-weight:700; color:#4a5161; }
  .ins-section{ display:flex; align-items:center; justify-content:space-between; margin-bottom:8px; }
  .ins-section-title{ font-weight:600; color:#6b7280; }

  /* ===== Nó estilo card branco ===== */
  :deep(.rete-node-card){
    background:#ffffff; border:1px solid #e6ebf2; border-radius:20px;
    min-width:420px;
    max-width:480px;          /* largura máxima */
    box-shadow:0 12px 30px rgba(16,24,40,.10);
    cursor: pointer;          /* pointer ao passar por cima do nó */
  }
  :deep(.rete-node-card .title.card-title){
    font-weight:800; font-size:20px; color:#111827;
    padding:16px 18px 4px 18px; border-bottom:0;
    display:flex; align-items:center; gap:10px; flex-wrap: wrap;
  }
  :deep(.rete-node-card .pill-start){
    margin-left:6px; font-size:11px; font-weight:800;
    background:#e7f5ff; color:#1e40af; border:1px solid #dbeafe; border-radius:999px; padding:2px 8px;
    display:inline-flex; align-items:center; gap:6px;
  }
  :deep(.rete-node-card .pill-end){
    margin-left:6px; font-size:11px; font-weight:800;
    background:#fff1f2; color:#b91c1c; border:1px solid #fecaca; border-radius:999px; padding:2px 8px;
    display:inline-flex; align-items:center; gap:6px;
  }
  :deep(.rete-node-card .pill-central){
    margin-left:6px; font-size:11px; font-weight:800;
    background:#f1f0ff; color:#6d28d9; border:1px solid #ddd6fe; border-radius:999px; padding:2px 8px;
    display:inline-flex; align-items:center; gap:6px;
  }
  .mr-25{ margin-right:.25rem }

  :deep(.rete-node-card .node-body){ padding:8px 18px 16px 18px; }
  :deep(.rete-node-card .node-preview){ display:flex; flex-direction:column; gap:10px; }

  /* conteúdo do nó */
  :deep(.pv-text){
    color:#6b7280; background:#f8fafc; border:1px solid #eef2f7; border-radius:12px;
    padding:10px 12px; font-weight:600;
  }
  :deep(.pv-actions){ display:flex; flex-direction:column; gap:10px; padding:12px; border:1px solid #eef2f7; border-radius:16px; background:#fbfdff; }
  :deep(.pv-chip){
    text-align:center; padding:10px 12px; border-radius:10px;
    border:1.5px solid #c7d2fe; background:#f8fafc; color:#1f2937; font-weight:600;
  }

  /* sockets pequenos como pontos escuros */
  :deep(.socket.input), :deep(.socket.output){
    width:8px; height:8px; border-radius:999px;
    background:#111827; border:2px solid #ffffff;
    box-shadow:0 2px 4px rgba(0,0,0,.12);
  }

  /* arestas */
  :deep(path.connection), :deep(svg .main-path){
    stroke:#1f2937 !important; stroke-width:2px; filter:drop-shadow(0px 2px 6px rgba(0,0,0,.10));
  }
  :deep(.selected path.connection){ stroke:#111827 !important; }

  /* rótulos nas arestas (textPath) */
  :deep(g.rete-edge-labels .edge-label-text){
    font-size:12px; font-weight:700; fill:#374151;
    stroke:#ffffff; stroke-width:6px; paint-order:stroke fill;
  }

  .mr-1{ margin-right:.25rem }
  </style>
